module.exports = __webpack_public_path__ + "img/patientassist.7d763a3a.svg";